import React, { useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DatePicker from '../DatePicker/index';
import 'react-day-picker/lib/style.css';
import actionConstants from '../../services/create_schedule/constants';
import { cancelSchedule, rescheduleEvent } from '../../services/create_schedule/actions';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
const dateFormat = 'MM/DD/YYYY'
const timeFormat = 'HH:mm A'


export default function RescheduleModal({
  isOpened,
  handleClose,
    eventName,
    dateTime,
    eventId,
    rescheduledata,

})

{
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const pending = useSelector(state => state.slotPickupData.pending)
    const dispatch = useDispatch();

    const handleDayClick = (day) => {
        setSelectedDate(day)
    }
    const handleTimeChange = (time) => {
        var timeValue = moment(time.target.value, "HH:mm A")
        timeValue = timeValue.format("HH:mm A")
        setSelectedTime(timeValue)
    }

    const handleCancel = () => {
        cancelSchedule({ eventId })(dispatch);
    };

    const handleRescheduleSave = () => {
        var datetime = (new Date(`${selectedDate} ${selectedTime.split(' ')[0]}`)).toISOString();
        var requestData = { eventId: eventId, newEventDate: selectedDate, newEventTime: selectedTime, schedules: rescheduledata, datetime: datetime }
        rescheduleEvent(requestData)(dispatch);
    }

  return (
      <Dialog
        open={isOpened}
        onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
          className="view-attendee-modal"
      >
        <DialogTitle id="responsive-dialog-title">
              {eventName}
        </DialogTitle>
        <DialogContent>
              <div>
                  <div className="date-time-set">
                      <span><b>When : </b> {dateTime}</span>
                  </div>
                  <div className="reschedule-event">
                      <p>RESCHEDULE THIS EVENT</p>  <Button variant="contained" className='notification-modal-close' onClick={() => handleCancel()} >CANCEL THIS EVENT</Button>
                  </div>
                  <div className="time-set-Picker">
                      <DatePicker
                          selectedDays={[selectedDate]}
                          onChange={handleDayClick}
                          format={dateFormat}
                          numberOfMonths={1}
                      //modifiers={datePickerModifiers}
                      //readOnly={readOnly || customTimeSlots}
                      />
                      <TextField
                          id="time"
                          type="time"
                          format={timeFormat}
                          onChange={handleTimeChange}
                          //defaultValue="07:30"
                          InputLabelProps={{
                              shrink: true,
                          }}
                          inputProps={{
                              step: 300, // 5 min
                          }}
                      />
                      

                  </div>
              </div>
        </DialogContent>
          <DialogActions>
              <Button variant="contained" className='notification-modal-close' disabled={selectedTime && selectedDate ? false : true  } onClick={() => handleRescheduleSave()}>SAVE</Button>
                   <Button variant="contained" className='notification-modal-close' onClick={() => handleClose()}>CANCEL</Button>
            </DialogActions>
      </Dialog>
  );
}